export const BOT_QUERY_KEY = 'bot';
export const BOTS_QUERY_KEY = 'bots';
export const BOT_TAGS_QUERY_KEY = 'botTags';
